import urlFile from "../common/ApiFile"
import url from "../common/api"
import {getQueries} from "../queries/getQueries.js"


export async function getTypeExpertList(){
    var datas=[]
    await getQueries("type_experts").then(data=>{
        
        data.map((element)=>{
           datas= [...datas,{value:element.id,label:element.libelle,sous_types:element.sous_type_experts}]
        })
    })
    
    return await _.sortBy(datas,"label")
}



